module.exports = __webpack_public_path__ + "img/LV3.932e7f28.svg";